export const DEFAULT_COOBBLIGATO = {
    "codice_fiscale": "", 
    "codice_identificativo": ""
};